import { PanelBottomClose, PanelRightClose } from 'lucide-react';

import { useBreakpointDown } from '@nesso/ui/hooks/use-breakpoint-down';
import { Button } from '@nesso/ui/primitives/button';
import { Card, CardAction, CardContent, CardHeader, CardTitle } from '@nesso/ui/primitives/card';

import { RecordingRecapCardList } from './recording-recap-card/recording-recap-card-list';

type Props = {
    onClose: () => void;
};

export function RecordingRecapCard({ onClose }: Props) {
    const isMobile = useBreakpointDown('md');

    return (
        <Card
            elevation="raised"
            className="max-h-[60vh] w-full overflow-y-auto md:h-full md:max-h-none"
        >
            <CardHeader>
                <CardTitle>What to include in your recap</CardTitle>
                <CardAction>
                    <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        aria-label="Close recap checklist"
                        onClick={onClose}
                    >
                        {isMobile ? (
                            <PanelBottomClose className="size-5" />
                        ) : (
                            <PanelRightClose className="size-5" />
                        )}
                    </Button>
                </CardAction>
            </CardHeader>
            <CardContent>
                <RecordingRecapCardList />
            </CardContent>
        </Card>
    );
}
